import {
  withTranslation,
} from 'react-i18next';

import ChampionshipResultTableEntryFieldsView from './ChampionshipResultTableEntryFieldsView';

const TranslatedComponent = withTranslation()(ChampionshipResultTableEntryFieldsView);

const Component = TranslatedComponent;

export default Component;
